<template>
  <BaseModal
    name="consumptionBalanceFirstStepModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close=""
    @before-open="loadData"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('consumptionBalanceFirstStepModal')"
      ></button>

      <div class="tw-text-center">
        <div class="tw-app-modal__title">{{ dataLang["reg_company_25"] }}</div>

        <div class="tw-app-modal__title tw-text-forText">
          {{ dataLang["reg_company_26"] }}
        </div>

        <div>
          {{ dataLang["reg_company_27"] }}
        </div>

        <BaseInputNew
          inputClass="tw-app-input-type-3 tw-mt-[15px]"
          placeholder=""
          input-name="minBalance"
          @input="updateValue"
          :horizontalTitle="true"
          value=""
          name-sign=""
        >
        </BaseInputNew>

        <div class="tw-mt-[15px]">
          {{ dataLang["reg_company_28"] }}
        </div>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('consumptionBalanceFirstStepModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["clients_register_text_96"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["reg_company_24"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable,
  },

  props: {},
  data() {
    return {
      localLoading: false,
      dataForEmit: {},
      pincode: "",
      currentId: null,
    };
  },
  methods: {
    loadData({ params }) {
      this.localLoading = true;
      this.pincode = params?.pincode;

      GeneralService.editOrCreate(
        `/super/companies/balance/out/step1?pincode=${this.pincode}`,
        {}
      )
        .then((gege) => {})
        .catch((e) => {
          console.error(e);
          this.$toast.error(e.response.data.message, { duration: 5000 });
          this.$modal.hide("consumptionBalanceFirstStepModal");
        })
        .finally(() => {
          this.localLoading = false;
        });
    },
    beforeClose(event) {
      this.dataForEmit = {};
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    sendData() {
      if (this.dataForEmit?.minBalance) {
        this.localLoading = true;
        GeneralService.editOrCreate(
          `/super/companies/balance/out/step2?pincode=${this.pincode}`,
          this.dataForEmit
        )
          .then((gege) => {
            console.log(gege);
            this.$toast.success(gege.data.message);
            this.$modal.show("сonsumptionBalanceSecondStepModal", {
              dataTable: gege.data.data,
              pincode: this.pincode,
              minBalance: this.dataForEmit?.minBalance,
            });
          })
          .catch((e) => {
            console.error(e);
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.$modal.hide("consumptionBalanceFirstStepModal");
            this.localLoading = false;
          });
      } else {
        this.$toast.error("Сначала загрузите файл", { duration: 5000 });
      }
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
